import { lazy } from 'react';

export const SellersPageAsync = lazy(() => import('./SellersPage'));
